import { render, staticRenderFns } from "./AddPartnerLayout.vue?vue&type=template&id=5e7ffc00&"
import script from "./AddPartnerLayout.vue?vue&type=script&lang=js&"
export * from "./AddPartnerLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports